import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import useReveal from "@/lib/useReveal";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import TopicPage from "@/pages/TopicPage";
import AdminPage from "@/pages/AdminPage";
import { RiskScorePage, AboutPage, ServicesPage, InsightsPage, PartnersPage, ContactPage } from "@/pages/InnerPages";
// TEMPORARY PREVIEW PASSWORD GATE — REMOVE BEFORE PUBLIC LAUNCH
import PreviewGate from "@/components/site/PreviewGate";

function ScrollAndHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // If a hash is present, scroll to the element (after a short tick so it mounts)
    if (hash) {
      const id = hash.slice(1);
      const go = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      const t = setTimeout(go, 80);
      const fix = setTimeout(go, 1400);
      return () => {
        clearTimeout(t);
        clearTimeout(fix);
      };
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function Shell() {
  useReveal();
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="App relative bg-[#050505] text-white min-h-screen font-body">
      {!isAdmin && <Header />}
      <ScrollAndHash />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/risk-score" element={<RiskScorePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/topics/:slug" element={<TopicPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      {/* TEMPORARY PREVIEW PASSWORD GATE — REMOVE BEFORE PUBLIC LAUNCH */}
      <PreviewGate>
        <Shell />
      </PreviewGate>
    </BrowserRouter>
  );
}

export default App;
